import { API_URL } from "../../constants";
import * as httpNetworking from "../../httpNetworking";

const VERSION = 1;

export async function createFreeInstance(appId: string) {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 50000
    };

    const result = await httpNetworking.simplePOSTRequest(
        `${API_URL}/user/app/${appId}/add-free-instance`,
        {},
        options,
        VERSION
    );
    return result.data;
}
